var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "12 29 46 46",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("rect", {
        attrs: {
          width: "46",
          height: "46",
          transform: "translate(12.2051 28.9141)",
          fill: "white",
        },
      }),
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_906_9019",
            maskUnits: "userSpaceOnUse",
            x: "12",
            y: "28",
            width: "47",
            height: "47",
          },
        },
        [
          _c("rect", {
            attrs: {
              x: "12.2051",
              y: "28.9141",
              width: "46",
              height: "46",
              rx: "6",
              fill: "#C4C4C4",
            },
          }),
        ]
      ),
      _c("g", { attrs: { mask: "url(#mask0_906_9019)" } }, [
        _c("path", {
          attrs: {
            d: "M58.2051 74.9143L58.2051 29.1602L12.4509 29.1602L12.4509 74.9143H58.2051Z",
            fill: "#FE7911",
          },
        }),
        _c("path", {
          attrs: {
            d: "M58.2052 29.1602C45.5706 29.1602 35.3281 39.4025 35.3281 52.0373V74.9143H58.2052V29.1602Z",
            fill: "#FD9924",
          },
        }),
        _c("path", {
          attrs: {
            d: "M12.4492 74.9143C25.0839 74.9143 35.3264 64.672 35.3264 52.0373V29.1602H12.4492V74.9143Z",
            fill: "#E24A04",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }